import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserApiService } from '../../shared/services/api/user-api.service';
import { PricingActionPermissionKey } from './pricing-action-permissions';
import { PricingActionDenialKind, denyToHome } from '../router/pricing-action-denial';

/**
 * Lets a pricing-action child activate only when the caller's profile carries `key`. Anything
 * else goes to Home carrying why: a profile that lacks the key is a plain deny, a profile that
 * could not be read at all is a failed check the reader may retry.
 */
export function pricingActionPermissionGuard(key: PricingActionPermissionKey): CanActivateFn {
  return async (_route, state) => {
    const userApi = inject(UserApiService);
    const router = inject(Router);
    const deny = (kind: PricingActionDenialKind) =>
      denyToHome(router, { kind, attemptedUrl: state.url });
    try {
      const me = await firstValueFrom(userApi.getUserData());
      return me.permissions?.includes(key) ? true : deny('permission-missing');
    } catch {
      // 401/403 are still the authTokenInterceptor's to redirect; every other failure lands here.
      return deny('permission-check-failed');
    }
  };
}
